import React from "react";
import { useSearchParams } from "react-router-dom";
import AcceptStaffInviteModal from "../../components/pages/Users/modal/acceptStaffInviteModal";

const AcceptInvitePage = () => {
  const [searchParams] = useSearchParams();

  const id = searchParams.get("id") || "";
  const showModal = Boolean(id);

  const handleClose = () => {
    window.history.replaceState({}, document.title, "/staff/accept-invite");
  };

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {showModal && (
        <>
          {/* bg */}
          <video
            className="absolute inset-0 w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/videos/Fleetrify-Bgss.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* overlay */}
          <div className="absolute inset-0 bg-black opacity-50"></div>

          {/* modal content*/}
          <div className="relative z-20 flex items-center justify-center w-full h-full">
            <AcceptStaffInviteModal
              isOpen={showModal}
              onClose={handleClose}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AcceptInvitePage;
